import { render, staticRenderFns } from "./UserCreateBusinesses.vue?vue&type=template&id=4cf4b948&"
import script from "./UserCreateBusinesses.vue?vue&type=script&lang=js&"
export * from "./UserCreateBusinesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports